// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3JikV","row":"ProcedureTreatmentSummary_row__3vkBl"};